import type { HTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

const Container = ({
  className = "",
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge("w-[1240px] max-w-full mx-auto px-5", className)}
      {...props}
    />
  )
}

export default Container
